export default __webpack_public_path__ + "static/media/linkedIn.6713f9ef.svg";